var _defs, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ae197d5cc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 128.746094 226.382812 L 621.488281 226.382812 L 621.488281 650.25 L 128.746094 650.25 Z M 128.746094 226.382812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae197d5cc8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 171.089844 226.863281 L 579.253906 226.863281 C 584.089844 226.863281 588.035156 230.683594 588.234375 235.472656 L 621.484375 640.589844 L 621.496094 640.589844 C 621.902344 645.535156 618.21875 649.878906 613.269531 650.28125 C 613.019531 650.300781 612.765625 650.3125 612.519531 650.3125 L 137.742188 650.3125 C 132.773438 650.3125 128.746094 646.289062 128.746094 641.320312 C 128.746094 640.945312 128.769531 640.570312 128.8125 640.207031 L 162.0625 235.152344 L 171.023438 235.855469 L 162.058594 235.117188 C 162.449219 230.394531 166.425781 226.828125 171.089844 226.863281 Z M 570.976562 244.839844 L 179.296875 244.839844 L 147.492188 632.335938 L 602.78125 632.335938 L 570.976562 244.839844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 506.445312 303.558594 C 516.136719 303.558594 523.992188 311.417969 523.992188 321.105469 C 523.992188 330.792969 516.136719 338.644531 506.445312 338.644531 C 496.757812 338.644531 488.894531 330.792969 488.894531 321.105469 C 488.894531 311.417969 496.757812 303.558594 506.445312 303.558594 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 243.828125 303.558594 C 253.519531 303.558594 261.375 311.417969 261.375 321.105469 C 261.375 330.792969 253.519531 338.644531 243.828125 338.644531 C 234.136719 338.644531 226.277344 330.792969 226.277344 321.105469 C 226.277344 311.417969 234.136719 303.558594 243.828125 303.558594 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 231.574219 328.1875 C 231.574219 333.15625 235.601562 337.179688 240.570312 337.179688 C 245.535156 337.179688 249.5625 333.15625 249.5625 328.1875 C 249.5625 214.132812 282.5 141.632812 324.664062 110.332031 C 340.246094 98.761719 357.074219 92.976562 373.832031 92.976562 C 390.589844 92.976562 407.417969 98.761719 423 110.332031 C 465.164062 141.632812 498.105469 214.128906 498.105469 328.1875 C 498.105469 333.15625 502.128906 337.179688 507.101562 337.179688 C 512.0625 337.179688 516.089844 333.15625 516.089844 328.1875 C 516.089844 207.820312 479.941406 130.28125 433.679688 95.933594 C 414.875 81.980469 394.390625 75 373.832031 75 C 353.273438 75 332.789062 81.980469 313.988281 95.933594 C 267.722656 130.28125 231.574219 207.820312 231.574219 328.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBlack);
export default __webpack_public_path__ + "static/media/cart_black.75367b30047b774a5b5cc278364d9876.svg";
export { ForwardRef as ReactComponent };